// @ts-nocheck

import React, { useState, useEffect, useRef } from "react";
import minusGloves from "../assets/icons/calculator/minusGloves.svg";
import plusGloves from "../assets/icons/calculator/plusGloves.svg";
import { observer } from "mobx-react";

const Counter = observer(({
  id,
  minCount,
  step,
  restart,
  propsCount,
  packsCounter = undefined,
  multiplicity,
}) => {
  multiplicity = multiplicity === null || multiplicity === 0 ? 1 : multiplicity;

  const counter = useRef("counter");
  const buttonMinus = useRef("buttonMinus");
  const buttonPlus = useRef("buttonPlus");
  const counterInput = useRef("counterInput");
  const [count, setCount] = useState(propsCount);
  const [fakeCount, setFakeCount] = useState(count);
  const [disabled, setDisabled] = useState(true);
  const [fetchCounts, setFetchCounts] = useState(1);

  const handlerToRes = () => {
    restart(id, count);
  };

  const mountedCounter3 = useRef(true);
  useEffect(() => {
    if (mountedCounter3.current) {
      // do componentDidMount logic
      let minusButton = buttonMinus.current;
      if (count <= minCount || count == 0) {
        setCount(minCount);
        setFakeCount(minCount);
      }
      if (count === minCount) {
        minusButton.classList.add("boxCount-button-disable");
        setDisabled(true);
      } else {
        minusButton.classList.remove("boxCount-button-disable");
        setDisabled(false);
      }
      mountedCounter3.current = false;
    } else {
      // do componentDidUpdate logic
      let minusButton = buttonMinus.current;
      if (count <= minCount || count == 0) {
        setCount(minCount);
        setFakeCount(minCount);
      }
      if (count === minCount) {
        minusButton.classList.add("boxCount-button-disable");
        setDisabled(true);
      } else {
        minusButton.classList.remove("boxCount-button-disable");
        setDisabled(false);
      }
      setFetchCounts(fetchCounts + 1);
    }
  }, [count, minCount]);

  const mountedCounter2 = useRef(true);
  useEffect(() => {
    if (mountedCounter2.current) {
      // do componentDidMount logic
      mountedCounter2.current = false;
    } else {
      // do componentDidUpdate logic
      handlerToRes();
    }
  }, [fetchCounts]);

  const minusHandler = () => {
    setCount(+count - step);
    setFakeCount(+fakeCount - step);
  };

  const plusHandler = () => {
    setCount(+count + step);
    setFakeCount(+fakeCount + step);
  };

  const fakeInputHandler = (e) => {
    setFakeCount(e.target.value);
  };

  const keypressHandler = (event) => {
    if (event.key === "Enter") {
      counterInput.current.blur();
    }
  };

  const inputHandler = (e) => {
    if (packsCounter) {
      setFakeCount(Math.round(e.target.value));
      setCount(Math.round(Number(e.target.value)));
      setFetchCounts(fetchCounts + 1);
      return;
    }

    let newCount = Math.round(e.target.value / multiplicity) * multiplicity;
    setFakeCount(Number(newCount));
    setCount(Number(newCount));
    setFetchCounts(fetchCounts + 1);
  };

  useEffect(() => {
    let minusButton = buttonMinus.current;
    setFakeCount(propsCount);
    setCount(propsCount);
    if (propsCount === minCount) {
      minusButton.classList.add("boxCount-button-disable");
      setDisabled(true);
    }else {
      minusButton.classList.remove("boxCount-button-disable");
      setDisabled(false);
    }
  }, [propsCount]);

  return (
    <>
      <div id={id} className='calc-counter gloves-counter' ref={counter}>
        <button
          disabled={disabled}
          className='boxCount-button boxCount-button-minus gloves-button'
          ref={buttonMinus}
          onClick={minusHandler}
        >
          <img loading="lazy" src={minusGloves} alt='-' />
        </button>

        {packsCounter ? (
          <input
            value={fakeCount}
            className='boxCount-counter gloves-counter-input packsCounter-js'
            ref={counterInput}
            onBlur={inputHandler}
            onChange={fakeInputHandler}
            min={minCount}
            type='number'
            onKeyPress={(event) => keypressHandler(event)}
          />
        ) : (
          <input
            value={fakeCount}
            className='boxCount-counter gloves-counter-input'
            ref={counterInput}
            onBlur={inputHandler}
            onChange={fakeInputHandler}
            min={minCount}
            type='number'
            onKeyPress={(event) => keypressHandler(event)}
          />
        )}
        <button
          className='boxCount-button gloves-button'
          ref={buttonPlus}
          onClick={plusHandler}
        >
          <img loading="lazy" src={plusGloves} alt='+' />
        </button>
      </div>
    </>
  );
})

export default Counter;
